import { type AxiosRequestConfig } from 'axios'
import { IQuest } from '../server/quests'

const updateQuest = (id: string, data: IQuest): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: `/quests/item/${id}`,
    data
  }
}

export { updateQuest }
